"use client"

import { Card, CardContent } from "@/components/ui/card"
import { Shield, Zap, Eye, Users, Code2 } from "lucide-react"

const pillars = [
  {
    icon: Zap,
    title: "Reduce Code Review Overhead",
    description:
      "Automate the repetitive parts of code review so your team can focus on architecture, design, and innovation.",
  },
  {
    icon: Shield,
    title: "Detect Vulnerabilities Earlier",
    description:
      "Identify security vulnerabilities and defects earlier in the lifecycle, before they reach production.",
  },
  {
    icon: Eye,
    title: "Improve Architectural Visibility",
    description:
      "Gain deep insight into your codebase structure, dependencies, and architectural patterns at a glance.",
  },
  {
    icon: Code2,
    title: "Support Decoupling & Modernization",
    description:
      "Facilitate system decoupling and modernization efforts with intelligent code understanding and analysis.",
  },
  {
    icon: Users,
    title: "Accelerate Onboarding",
    description:
      "Help new team members understand complex repositories faster through intelligent code exploration and context.",
  },
]

export function MissionSection() {
  return (
    <section className="px-6 py-24">
      <div className="mx-auto max-w-6xl">
        <div className="mb-16 text-center">
          <span className="mb-4 inline-block text-sm font-semibold uppercase tracking-widest text-primary">
            Our Mission
          </span>
          <h2 className="text-balance text-3xl font-bold text-foreground md:text-5xl">
            How We Help <span className="text-primary">Engineering Teams</span>
          </h2>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {pillars.map((pillar) => {
            const Icon = pillar.icon
            return (
              <Card
                key={pillar.title}
                className="group border-border/50 bg-card/50 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5"
              >
                <CardContent className="pt-6">
                  <div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-primary/10 transition-colors duration-300 group-hover:bg-primary/20">
                    <Icon className="size-6 text-primary" />
                  </div>
                  <h3 className="mb-2 text-lg font-semibold text-foreground">
                    {pillar.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">
                    {pillar.description}
                  </p>
                </CardContent>
              </Card>
            )
          })}
        </div>
      </div>
    </section>
  )
}
